import gql from 'graphql-tag';

export default gql`
  mutation deleteAccountActivity($id: ID!) {
    accountActivity: deleteAccountActivity(id: $id) {
      id
    }
  }
`;
